module.exports = __webpack_public_path__ + "assets/img/icon_vip.dfaa1fb6.png";